import React from 'react'

const renderTextarea = ({input, label, placeholder, tooltip, meta: {touched, error}}) => (
	<div>
		<div className={tooltip ? "input-group" : ""}>
			<span className="small">{label}</span>
			<textarea {...input} placeholder={placeholder} type="textarea" className={"form-control" + ((touched && error) ? " invalid": "")}/>
			<span className="small tooltip-text">{tooltip}</span>
			{touched && error && (error!=="Required") &&<div className="error">{error}</div>}
		</div>
	</div>
)

export default renderTextarea


// WEBPACK FOOTER //
// ./src/components/fields/renderTextarea.js